import {getQueryStringVariable, getFullHeight, getFullWidth} from "./utilities";

/**
 * One Single video player that plays all of the featured videos on the site.
 *
 * TODO: add close button to feature video player
 * TODO: add controls to feature video player
 * TODO: remove click anywhere to close
 */
let FeatureVideoPlayer = function (params) {
  // console.log('FeatureVideoPlayer initalizing ' + params);

  let self = this;

  let parentWrapper = document.getElementById('bp3-wrapper');
  let contentElement = parentWrapper.querySelector('#content');
  // let videoPreviews = contentElement.querySelector('#section1-preview' );
  let videoPreviews = contentElement.querySelectorAll('.video-preview' );
  // videoPreviews.addEventListener('click', previewClicked);
  // let index = 0;
  videoPreviews.forEach(function(preview) {
    // index++;
    // copy for scope
    // let sectionIndex = index;
    let sectionId = preview.getAttribute('data-section-id');
    preview.addEventListener('click', function () {
      // previewClicked(sectionIndex);
      previewClicked(sectionId);
    });
  })

  let videoBlackout = parentWrapper.querySelector('#video-blackout');
  let featureVideoPlayer = parentWrapper.querySelector('#feature-video-player');
  let featureVideo = featureVideoPlayer.querySelector('#feature-video');
  let closeButtonWrapper = featureVideoPlayer.querySelector('#close-button-wrapper');
  let closeButton = featureVideoPlayer.querySelector('#close-button');
  let videoFadeDuration = 0.3;

  let featureVideoIsOpen = false;


  function previewClicked(sectionId) {
    // console.log('preview clicked ' + sectionId);
    // console.log('event target is ',  event.target);
    if (featureVideoIsOpen === false) {
      // window.featureVideoIndex = index;
      //get the video data
      let previewElement = parentWrapper.querySelector('#' + sectionId.toString() + '-preview');
      // set the data-title attribute for analytics
      let title = previewElement.getAttribute('data-title');
      featureVideo.setAttribute('data-title', title);
      
      let videoFile = previewElement.getAttribute('data-video');
      console.log('video file is ' + videoFile);
      let posterFile = previewElement.getAttribute('data-poster');
      featureVideo.setAttribute('poster', posterFile);
      featureVideo.querySelector('source').setAttribute('src', videoFile);
      featureVideo.load();

      gsap.to('#content', {opacity: 0, duration: videoFadeDuration, onComplete: function () {
          playVideo(sectionId);
        }});
      featureVideoIsOpen = true;
    }
  }

  let videoWrapper = featureVideoPlayer.querySelector('#video-wrapper');
  // let resizeTimer = null;
  function setVideoSize() {
    // if (resizeTimer !== null) {
    //   clearTimeout(resizeTimer);
    //   resizeTimer = null;
    // }
    // resizeTimer = setTimeout( function() {
      // feature video dimensions
      const videoWidth = 1920;
      const videoHeight = 1080;
      const maxWidth = getFullWidth() * 0.90;
      const maxHeight = getFullHeight() * 0.90;
      // calc video scale based on full width
      let widthScale = videoWidth / maxWidth;
      let heightScale = videoHeight / maxHeight;
      let scale = Math.max(widthScale, heightScale);
      featureVideo.style.width = Math.round(videoWidth / scale).toString() + 'px';
      featureVideo.style.height = Math.round(videoHeight / scale).toString() + 'px';
      videoWrapper.style.width = Math.round(videoWidth / scale).toString() + 'px';
      videoWrapper.style.height = Math.round(videoHeight / scale).toString() + 'px';
      console.log('video sized to ' + videoWrapper.style.width + ' x ' + videoWrapper.style.height);
    // }, 500);
  }

  let currentSectionId = "";
  function playVideo(sectionId) {
    // console.log('play video ' + sectionId)
    currentSectionId = sectionId;

    // pause the bg video if it exists
    let currentVideo = parentWrapper.querySelector('#' + sectionId.toString() + '-video-bg');
    if (currentVideo !== null) {
      currentVideo.pause();
      // console.log('paused ', currentVideo);
    }

    setVideoSize();
    //TODO: debounce this?
    window.addEventListener('resize', setVideoSize);
    window.addEventListener('orientationchange', setVideoSize);
    featureVideoPlayer.style.display = "flex";
    videoBlackout.style.display = "block";

    gsap.fromTo(videoBlackout, {opacity: 0}, {opacity: 0.7, duration: videoFadeDuration});

    // featureVideo.play();
    gsap.to(featureVideoPlayer, {opacity: 1, duration: videoFadeDuration, onComplete: function () {
        featureVideo.play();
        window.clickHandler = function () {
          closeVideo(sectionId);
        }
        closeButton.addEventListener('click', window.clickHandler);
        // window.addEventListener('scroll', window.clickHandler);

        // close when the video ends
        featureVideo.addEventListener('ended', window.clickHandler,false);
      }
    });
  }

  function closeVideo(sectionId) {
    if (featureVideoIsOpen === true) {
      closeButton.removeEventListener('click', window.clickHandler);
      // window.removeEventListener('scroll', window.clickHandler);
      featureVideo.removeEventListener('ended', window.clickHandler,false);
      window.removeEventListener('resize', setVideoSize);
      window.removeEventListener('orientationchange', setVideoSize);
      featureVideo.pause();
      gsap.to(videoBlackout, {opacity: 0, duration: videoFadeDuration});
      gsap.to(featureVideoPlayer, {opacity: 0, duration: videoFadeDuration, onComplete: function () {
          featureVideoPlayer.style.display = "none";
          videoBlackout.style.display = "none";
          // set page to the right spot on close
          contentElement.querySelector('#' + currentSectionId + '-preview').scrollIntoView();
          gsap.to('#content', {opacity: 1, duration: videoFadeDuration});
          // play the bg video if it exists
          let currentVideo = parentWrapper.querySelector('#' + sectionId.toString() + '-video-bg')
          if (currentVideo !== null) {
            currentVideo.play();
            // console.log('played ', currentVideo);
          }
        }
      });
      featureVideoIsOpen = false;
    }
  }

};

export default FeatureVideoPlayer;

